import { connect } from "react-redux";
import { DesignChapter } from "@learningblocks/storybook-components";

import { getHintsData } from "./Hint.selector";

function mapStateToProps(state) {
  return getHintsData(state);
}

function mapDispatchToProps() {
  return {};
}

export const Hint = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignChapter.Hint);
